/**
 * EthereumStakingValidatorStatus
 */
enum ValidatorStatusEnum {
  /**
   * Payment has been authorized and order is ready for shipment, but no items in the order have been shipped.
   */
  PENDING = 'pending',
  /**
   * One or more validators in the order have been shipped.
   */
  ACTIVE = 'active',
  /**
   * all validators exit
   */
  EXIT = 'exit',
  SLASHED = 'slashed',
}
export { ValidatorStatusEnum };
